import React from 'react'
import { Button } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { ArrowsAltOutlined, ShrinkOutlined } from '@ant-design/icons'
import groupSelectors from '../../../../../store/selectors/group.selectors'
import useSubmissionGroups from '../submission-groups/useSubmissionGroups'
import { groupActions } from '../../../../../store/slices/group.slice'

const CollapseAllGroupsToggle = () => {
    const collapsedGroupIds = useSelector(groupSelectors.collapsedGroupIds)
    const dispatch = useDispatch()
    const { groups } = useSubmissionGroups()

    const handleToggleAllGroupsCollapse = () => {
        if (collapsedGroupIds.length) {
            dispatch(groupActions.setCollapsedGroupsKeys([]))
            dispatch(groupActions.toggleGlobalCollapse())
        } else {
            dispatch(groupActions.setCollapsedGroupsKeys(groups.map(group => group.id)))
            dispatch(groupActions.toggleGlobalCollapse())
        }
    }

    return (
        <Button
            onClick={handleToggleAllGroupsCollapse}
            icon={collapsedGroupIds.length ? <ArrowsAltOutlined /> : <ShrinkOutlined />}
        >
            {collapsedGroupIds.length ? 'Expand all' : 'Collapse all'}
        </Button>
    )
}

export default CollapseAllGroupsToggle
